import { Pipe, PipeTransform } from '@angular/core';

import { PriceModificationType } from 'app/modules/pricing/interfaces/pricing.interface';

@Pipe({
  name: 'pricingCalculation',
})
export class PricingCalculationPipe implements PipeTransform {
  transform(price :number, discount :number, modificationType :PriceModificationType = PriceModificationType.PERCENT) :number {
    if (modificationType === PriceModificationType.FIXED) {
      return Number((price - Number(discount)).toFixed(2));
    }

    // Default to percent
    return Number((price - (Number(discount) / 100) * price).toFixed(2));
  }
}
